'use client';
import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

export default function CalculatorSection() {
  const [length, setLength] = useState(10);
  const [width, setWidth] = useState(0.5);  
  const [height, setHeight] = useState(0.3); 

  const volume = (length * width * height).toFixed(2);

  return (
    <section id="calculator" className="py-16 sm:py-20 px-4 sm:px-6 bg-background">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-3 text-foreground">
          Калькулятор бетона
        </h2>
        <p className="text-base sm:text-lg text-muted-foreground mb-10 sm:mb-12 max-w-2xl">
          Быстро рассчитайте необходимый объём бетона для вашего проекта.
        </p>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
          <div className="space-y-5 sm:space-y-6">
            <div>
              <label className="block text-sm font-bold text-foreground mb-2">
                Длина (пог. м): {length}
              </label>
              <input
                type="range"
                min="1"
                max="200"
                step="0.5"
                value={length}
                onChange={(e) => setLength(parseFloat(e.target.value))}
                className="w-full h-2 bg-border rounded-lg appearance-none cursor-pointer"
              />
            </div>
            <div>
              <label className="block text-sm font-bold text-foreground mb-2">
                Ширина (м): {width.toFixed(2)}
              </label>
              <input
                type="range"
                min="0.1"
                max="5"
                step="0.05"
                value={width}
                onChange={(e) => setWidth(parseFloat(e.target.value))}
                className="w-full h-2 bg-border rounded-lg appearance-none cursor-pointer"
              />
            </div>
            <div>
              <label className="block text-sm font-bold text-foreground mb-2">
                Высота (м): {height.toFixed(2)}
              </label>
              <input
                type="range"
                min="0.2"
                max="3"
                step="0.05"
                value={height}
                onChange={(e) => setHeight(parseFloat(e.target.value))}
                className="w-full h-2 bg-border rounded-lg appearance-none cursor-pointer"
              />
            </div>
          </div>

          <div className="bg-card border border-border rounded-2xl p-6 sm:p-8 space-y-5 sm:space-y-6">
            <div className="flex items-center gap-3">
              <Icon name="CubeIcon" size={32} className="text-primary shrink-0" />
              <div>
                <p className="text-sm text-muted-foreground">Общий объём бетона</p>
                <p className="text-3xl sm:text-4xl font-bold text-foreground">{volume} м³</p>
              </div>
            </div>
            <button
              onClick={() => {
                const el = document.querySelector('#contact');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="w-full bg-primary text-primary-foreground px-6 py-3.5 sm:py-3 rounded-xl font-semibold hover:bg-accent transition-all duration-300 flex items-center justify-center gap-2"
            >
              Оставить заявку
              <Icon name="ArrowRightIcon" size={18} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}